import React from 'react'
import './PropertySettings.scss'
import {
  Layers,
  FileCopy,
  ColorLens,
  InsertChart,
  SaveAlt,
  Delete,
  Undo,
  Save,
  Sync
} from '@material-ui/icons'
import Tooltip from '@material-ui/core/Tooltip'
import PropTypes from 'prop-types'
import {
  TemplateSettings,
  BarChartSettings,
  PageListContainer,
  ColorPickerSettings,
  PropertySearch
} from '@components/custom'
import IconButton from '@material-ui/core/IconButton'
import SearchIcon from '@material-ui/icons/Search'
import { connect } from 'react-redux'
import Comps from '@engine/comps'
import ListRefreshDialog from '../ListRefreshDialog/ListRefreshDialog'

export class PropertySettings extends React.Component {
  constructor(props) {
    super(props)
    this.state = { tabIndex: 0, isRefreshClicked: false }
  }

  componentDidUpdate = prevProps => {
    if ((prevProps.subject && prevProps.subject?.name !== this.props.subject?.name)) {
      this.setState({
        subject: this.props.subject
      })
    }
  }

  tabSelectedHandler = newValue => {
    this.setState({ ...this.state, tabIndex: this.state.tabIndex === newValue ? -1 : newValue })
  }

  // eslint-disable-next-line complexity
  render() {
    const {
      propertyData,
      toggleDiscardDialog,
      refreshListInfo,
      downloadPDF,
      gotoPropertyPreview,
      properties,
      resetflag,
      resetComps,
      handleDeleteClick,
      barChartData,
      reArrangeComps,
      editThemeColors,
      handleSaveProjectDialog,
      projectName,
      match: { params },
      donutChartThemeColors,
      templateName,
      getProperties,
      getPropertyInfo,
      propertiesData,
      subject,
      closeSourceDialog,
      listName,
      polarisPropertySearchCriteriaId,
      omniViewPropertyListId
    } = this.props
    const { tabIndex } = this.state
    const noProjectName = !(projectName && projectName.trim())
    const isSaveDisabled = params && params.projectId ? !resetflag || noProjectName : noProjectName
    const ignoreWhenList = ['rentCompsT6', 'salesCompsT2']

    const refreshHandler = () => {
      this.setState({ ...this.state, isRefreshClicked: true })
    }

    const cancelProjectRefreshHandler = () => {
      this.setState({ ...this.state, isRefreshClicked: false })
    }

    const confirmProjectRefreshHandler = selectedRefreshOption => {
      this.setState({ ...this.state, isRefreshClicked: false })
      refreshListInfo(selectedRefreshOption)
    }

    return <div data-testid="property-list" className="property-settings-pane">
        <div className="min_view">
          <div>
            <div className="menu_icon_div">
              <Tooltip title="Page List" placement="right">
                <Layers data-testid="page-list-settings-tab" onClick={() => this.tabSelectedHandler(0)} className={`${tabIndex === 0 ? 'menu_icons menu_icons_active' : 'menu_icons'}`} />
              </Tooltip>
            </div>
            <div className="menu_icon_div">
              <Tooltip title="Template" placement="right">
                <FileCopy data-testid="template-settings-tab" onClick={() => this.tabSelectedHandler(1)} className={`${tabIndex === 1 ? 'menu_icons menu_icons_active' : 'menu_icons'}`} />
              </Tooltip>
            </div>
            <div className="menu_icon_div">
              <Tooltip title="Color Theme" placement="right">
                <ColorLens onClick={() => this.tabSelectedHandler(2)} className={`${tabIndex === 2 ? 'menu_icons menu_icons_active' : 'menu_icons'}`} />
              </Tooltip>
            </div>
            {!ignoreWhenList.includes(templateName) && <div className="menu_icon_div">
                <Tooltip title="Bar Chart" placement="right">
                  <InsertChart data-testid="barchart-options-tab" onClick={() => {
                      this.tabSelectedHandler(3)
                      gotoPropertyPreview('barcharts')
                    }} className={`${tabIndex === 3 ? 'menu_icons menu_icons_active' : 'menu_icons'}`} />
                </Tooltip>
              </div>}
            <div className="menu_icon_div">
              <Tooltip title="Search to Add a Property" placement="right">
                <SearchIcon onClick={() => this.tabSelectedHandler(4)} className={`${tabIndex === 4 ? 'menu_icons menu_icons_active' : 'menu_icons'}`} />
              </Tooltip>
            </div>
          </div>
          <div>
            {(omniViewPropertyListId || polarisPropertySearchCriteriaId) && listName?.length > 0 && <div className="menu_icon_div">
                <Tooltip title="Refresh Project with OV List" placement="right">
                  <Sync className="menu_icons" data-testid="proplist-refresh" onClick={() => refreshHandler()} variant="contained" id="proplist-refresh" size="large" />
                </Tooltip>
              </div>}
            {resetflag && <div className="menu_icon_div proplist-reset-btn">
                <Tooltip title="Reset" placement="right">
                  <Undo className="menu_icons" data-testid="proplist-reset" onClick={() => resetComps()} variant="contained" id="proplist-reset" />
                </Tooltip>
              </div>}
            <div className="menu_icon_div">
              <Tooltip title="Discard" placement="right">
                <Delete className="menu_icons" data-testid="proplist-discard" onClick={() => toggleDiscardDialog()} variant="contained" id="proplist-discard" size="large" />
              </Tooltip>
            </div>
            <div className="menu_icon_div">
              <Tooltip title="Download" placement="right">
                <SaveAlt className="menu_icons" data-testid="button-download" onClick={() => downloadPDF()} variant="contained" id="button-download" size="large" />
              </Tooltip>
            </div>
            <div className="menu_icon_div">
              <Tooltip title="Save" placement="right">
                <div>
                  <IconButton aria-label="SaveCompsProject" data-testid="button-save-comps-project" onClick={() => handleSaveProjectDialog('open')} disabled={isSaveDisabled} id="button-save-comps-project">
                    <Save className={isSaveDisabled ? 'menu_icons_disabled' : 'menu_icons'} variant="contained" size="large" />
                  </IconButton>
                </div>
              </Tooltip>
            </div>
          </div>
        </div>
        {this.state.tabIndex !== -1 && <div className="max_view properties-view">
            {this.state.tabIndex === 0 && <PageListContainer propertyData={propertyData} gotoPropertyPreview={gotoPropertyPreview} subject={subject} properties={properties} handleDeleteClick={handleDeleteClick} barChartData={barChartData} reArrangeComps={reArrangeComps} />}
            {this.state.tabIndex === 1 && <TemplateSettings />}
            {this.state.tabIndex === 2 && <ColorPickerSettings editThemeColors={editThemeColors} donutChartThemeColors={donutChartThemeColors} />}
            {this.state.tabIndex === 3 && <BarChartSettings />}
            {this.state.tabIndex === 4 && <PropertySearch getProperties={getProperties} propertiesData={propertiesData} getPropertyInfo={getPropertyInfo} closeSourceDialog={closeSourceDialog} />}
          </div>}

        {this.state.isRefreshClicked && <ListRefreshDialog isRefreshClicked={this.state.isRefreshClicked} listName={listName} cancelProjectRefreshHandler={cancelProjectRefreshHandler} confirmProjectRefreshHandler={confirmProjectRefreshHandler}/>}
      </div>
  }
}

PropertySettings.propTypes = {
  editThemeColors: PropTypes.func,
  resetflag: PropTypes.bool,
  propertyData: PropTypes.array,
  toggleDiscardDialog: PropTypes.func,
  handleDeleteClick: PropTypes.func,
  downloadPDF: PropTypes.func,
  gotoPropertyPreview: PropTypes.func,
  properties: PropTypes.array,
  subject: PropTypes.array,
  reArrangeComps: PropTypes.func,
  resetComps: PropTypes.func,
  barChartData: PropTypes.array,
  handleSaveProjectDialog: PropTypes.func,
  projectName: PropTypes.string,
  match: PropTypes.object,
  donutChartThemeColors: PropTypes.object,
  templateName: PropTypes.string,
  getProperties: PropTypes.func,
  propertiesData: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  getPropertyInfo: PropTypes.func,
  closeSourceDialog: PropTypes.bool,
  listName: PropTypes.string,
  polarisPropertySearchCriteriaId: PropTypes.string,
  omniViewPropertyListId: PropTypes.string,
  refreshListInfo: PropTypes.func
}

const mapStateToProps = state => ({
  templateName: Comps.selectors.comps.templateName(state),
  listName: Comps.selectors.comps.listName(state),
  polarisPropertySearchCriteriaId: Comps.selectors.comps.polarisPropertySearchCriteriaId(state),
  omniViewPropertyListId: Comps.selectors.comps.omniViewPropertyListId(state)
})

export default connect(mapStateToProps)(PropertySettings)
